import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as homeActions from '../home/redux/actions';
import * as commonActions from '../common/redux/actions';
import { drapcodeIcon } from '../../common/custom/icon-library';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Form, Formik, Field } from 'formik';
import { CsvDataDisplay } from './CsvDataDisplay';
import { showAlertHtml } from '../../common/utils/alert';
import { FileUpload } from '../../common/formElements/FileUpload';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import _ from 'lodash';
import { toast } from 'react-toastify';

export class CollectionWithJson extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
  };
  state = {
    jsonData: [],
    collectionName: '',
    creationFailedMsg: '',
    isPersistent: true,
    jsonConfig: {},
    optionalPath: '',
  };

  uploadFile = (file) => {
    const { actions } = this.props;
    const { optionalPath } = this.state;
    if (file && file.type === 'application/json') {
      const parts = file.name.split('.');
      const firstPart = parts[0];
      const correctName = firstPart.replace(/[^a-zA-Z]/g, '');
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const content = JSON.parse(e.target.result);
          const final = optionalPath ? _.get(content, optionalPath) : content;
          if (!final) {
            toast.error('Please Enter Correct Path');
            return;
          }
          const keysArray = Object.keys(final);
          this.setState({ jsonData: keysArray, collectionName: correctName });
          actions.toggleIsOpenCollectionCreateWithCsv();
        } catch (error) {
          toast.error('Error in parsing this JSON .');
          return;
        }
      };
      reader.readAsText(file);
    } else {
      console.log('Please select a JSON file');
    }
  };
  setCollectionName = (value) => {
    this.setState({ collectionName: value });
  };
  updateJsonConfig = (value) => {
    this.setState({ jsonConfig: value });
  };
  handleFormSubmit = async () => {
    const { projectId, actions, commonActions, version } = this.props;
    const data = {
      collectionTitle: this.state.collectionName,
      willPersist: this.state.isPersistent,
      fields: this.state.jsonConfig,
      projectId,
      version,
    };

    const createCollectionResponse = await actions.createCollectionWithJson(data);
    await actions.loadProjectCollections({ projectId, version });
    if (createCollectionResponse && createCollectionResponse.data.uuid) {
      commonActions.trackCollectionChange({
        uuid: createCollectionResponse.data.uuid,
        name: createCollectionResponse.data.collectionName,
      });

      this.props.homeActions.loadEditorCollections({ projectId, version });
      const collectionId = createCollectionResponse.data.uuid;
      actions.loadProjectCollectionDetail({ projectId, collectionId, version });
      if (this.props.home && this.props.home.collections.length === 0) {
        this.props.projectOnBoardActions.changeProjectStatus({
          state: 'COLLECTION_CREATED',
          status: 'COMPLETE',
          projectId,
          version,
        });
      }
      const redirectPath = `/collections/${version}/v/${projectId}/edit/${collectionId}`;
      this.props.history.push(redirectPath);
      actions.toggleIsOpenCollectionCreateWithCsv();
      return;
    }
  };
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };
  setCheckboxChange = (event) => {
    const { name, checked } = event.target;
    if (name === 'willPersist') {
      const confirmationMsg = checked
        ? `The DrapCode (default) database will be used to store and retrieve data.<br/><br/>Do you want to proceed?`
        : `Data will be fetched from an external source.<br/>Hence, you will <strong>not</strong> be able to store item data in the DrapCode (default) database.<br/><br/>Do you want to proceed?`;
      const preConfirm = () => {
        this.setState({ isPersistent: checked });
      };
      showAlertHtml(confirmationMsg, preConfirm, 'Proceed');
    } else {
      this.setState({ [name]: checked });
    }
  };
  render() {
    const { collections, actions, projectId } = this.props;
    const { isPersistent, collectionName, jsonConfig, optionalPath, jsonData } = this.state;
    const typeDescription = `<ul style="padding-left:1rem"><li><strong>Persistent collection</strong> when <em>ON</em> will store item data in <em>DrapCode (default) database</em>.</li><li><strong>Persistent collection</strong> when <em>OFF</em> will not store any item data in <em>DrapCode (default) database</em>.</li></ul>`;
    return (
      <div className="card">
        <div className="card-header card-header-icon" data-background-color="drapcode-dark-blue">
          <i className={`wb ${drapcodeIcon('collection')}`}></i>
        </div>
        <div className="card-content">
          <div className="card-title-header">
            <h4 className="card-title">
              Create Collection <span style={{ textTransform: 'none' }}>via</span> JSON
            </h4>
          </div>
          <Formik>
            {() => {
              return (
                <Form className="form-horizontal">
                  <div className="row mx-auto">
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 mb-4">
                      {jsonData.length > 0 && (
                        <Modal
                          isOpen={collections.isOpenCollectionCreateWithCsv}
                          toggle={() => {
                            actions.toggleIsOpenCollectionCreateWithCsv();
                          }}
                          backdrop="static"
                          style={{ maxWidth: '40%', marginTop: '70px' }}
                        >
                          <ModalHeader
                            toggle={() => {
                              actions.toggleIsOpenCollectionCreateWithCsv();
                            }}
                            className="border-bottom"
                          >
                            <strong>Create Collection via JSON</strong>
                          </ModalHeader>
                          <ModalBody>
                            <CsvDataDisplay
                              csvHeader={jsonData}
                              onUpdateJsonConfig={this.updateJsonConfig}
                              collectionName={collectionName}
                              jsonConfig={jsonConfig}
                              setCollectionName={this.setCollectionName}
                              onSubmitForm={this.handleFormSubmit}
                              actions={actions}
                              isPersistent={isPersistent}
                              setCheckboxChange={this.setCheckboxChange}
                              typeDescription={typeDescription}
                              collections={this.props.collections}
                            />
                          </ModalBody>
                        </Modal>
                      )}
                      <FileUpload
                        projectId={projectId}
                        maxFiles={1}
                        accept={'.json'}
                        maxSizeBytes="20971520"
                        fileIcon="customTheme"
                        uploadFile={this.uploadFile}
                        defaultUpload={false}
                      />
                    </div>
                    <FormFieldWithLabel
                      cta={false}
                      icon="text"
                      infoIcon={true}
                      infoDescription={`If you want to Create From Nested JSON provide a desired Full key Path, Example: {a: b, c: {d: e, f: {g: h}}} In this example, c contains another nested object with keys d and f. If you want d and f Enter c`}
                    >
                      <Field
                        type="text"
                        name="optionalPath"
                        className="form-control"
                        data-lang="en"
                        placeholder="Object Path (Optional)"
                        onChange={this.handleChange}
                        value={optionalPath}
                      />
                      {}
                    </FormFieldWithLabel>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    homeActions: bindActionCreators({ ...homeActions }, dispatch),
    commonActions: bindActionCreators({ ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionWithJson);
